import React, { Dispatch, SetStateAction } from "react";
import InsightFiltersViewModel from "../../ViewModels/InsightFiltersViewModel";
import SelectFilterContainer from "../GenericFilters/Select/SelectFilterContainer";

interface ITimePeriodFilterContainerProps {
    filters: InsightFiltersViewModel
    setFilters: Dispatch<SetStateAction<InsightFiltersViewModel>>
}

export default function TimePeriodFilterContainer({ filters, setFilters }: ITimePeriodFilterContainerProps) {
    const options = ['Day', 'Week', 'Month', 'Year', 'Manual'];

    return (
        <>
            <SelectFilterContainer
                filters={filters}
                setFilters={setFilters}
                name='timePeriod'
                label='Time Period'
                options={options} />
        </>
    );
};
